export default __webpack_public_path__ + "static/app-store-b342b5cb6eb6b67c54974dd76d7f702e.svg";